<template>
    <div>
        <el-form
            :model="dataForm"
            :rules="dataRule"
            ref="dataForm"
            label-width="120px"
        >
            <el-form-item label="主题色" prop="themeColor">
                <el-color-picker v-model="dataForm.themeColor" show-alpha :predefine="predefineColors"></el-color-picker>
            </el-form-item>
            <el-form-item label="网站标题" prop="pageTitle">
                <el-input v-model="dataForm.pageTitle" placeholder="请输入网站标题"></el-input>
            </el-form-item>
            <el-form-item label="网页logo" prop="logoUrl">
                <el-upload
                    action="/api/file/uploadFile"
                    list-type="picture-card"
                    :limit="1"
                    :headers="headers"
                    :before-upload="beforeLogoUpload" 
                    :file-list="logoList"
                    :on-exceed="handleExceed"
                    :on-success="handleLogoSuccess" 
                    :on-remove="handLogoRemove"
                    >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="网页背景" prop="bgUrl">
                <el-upload
                    action="/api/file/uploadFile"
                    list-type="picture-card"
                    :limit="1"
                    :file-list="bgcList"
                    :auto-upload="false"
                    :on-change="selectChange"
                    :on-exceed="handleExceed"
                    :on-remove="handBgcRemove"
                    >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">只能上传JPG,PNG文件，推荐最佳尺寸1920*640</div>
                </el-upload>
            </el-form-item>

            <el-form-item label="网页ico" prop="icoUrl">
                <el-upload
                    ref="uploadIco"
                    :limit="1"
                    :headers="headers"
                    action="/api/file/uploadFile"  
                    list-type="picture-card"
                    accept=".ico"
                    :file-list="icoList"
                    :before-upload="beforeIcoUpload" 
                    :on-success="handleIcoSuccess" 
                    :on-exceed="handleExceed"
                    :on-remove="handIcoRemove"
                >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">只能上传ico文件，且不超过500KB</div>
                </el-upload>
            </el-form-item>
            
            <el-form-item label="网页页脚">
                <el-switch v-model="flag"></el-switch>
                <template v-if="flag">
                    <el-input placeholder="请输入技术支持单位" v-model="footForm.support">
                        <template slot="prepend">技术支持</template>
                    </el-input>
                    <el-input placeholder="请输入联系邮箱" v-model="footForm.email">
                        <template slot="prepend">联系我们</template>
                    </el-input>
                </template>
            </el-form-item>
        </el-form>
        <cropper :cropperImg="cropperImg" @uploadImg="uploadImg"/>
        <div style="text-align:right">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
        </div>
    </div>
</template>

<script>
import { add , update} from "@/api/shenbao/shenbao-page"
import { getInfoEntity as getInfoPageEntity } from "@/api/shenbao/shenbao-page"
import { getToken } from '@/utils/auth'
import cropper from '@/components/common/cropper'
export default {
    props: {
        shenbaoId:{
            type:String,
            default: ''
        },
    },
    components:{
        cropper
    },
    data() {
        return {
            cropperImg:'',
            headers: {
                token: getToken()  //携带token上传,不然会报错
            },
            dataForm:{},
            imageUrl:'',
            flag: false,
            footForm:{},
            icoList:[],
            logoList:[],
            bgcList:[],
            visible: false,
            predefineColors: [
                '#2F3A59',
                '#6B4166',
                '#ffd700',
                '#90ee90',
                '#ffffff'
            ],
            dataRule: {
                themeColor: [
                    {
                        required: true,
                        message: "主题色不能为空",
                        trigger: "blur"
                    }
                ],
                logoFileUid: [
                    {
                        required: true,
                        message: "网页logo不能为空",
                        trigger: "blur"
                    }
                ],
                pageTitle:[
                    {
                        required: true,
                        message: "网页标题不能为空",
                        trigger: "blur"
                    }
                ],
                icoFileUid: [
                    {
                        required: true,
                        message: "网页ico不能为空",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch:{
        shenbaoId: {
            immediate:true,
            handler: function(newVal) {
                if(newVal)  {
                    this.getInfoPageEntity(newVal)
                }
            }
        }
    },
    methods: {
        getInfoPageEntity(id){
            this.logoList = []
            this.icoList = []
            getInfoPageEntity(id).then(res=>{
                if(res){
                    this.dataForm = res
                    let logoObj = new Object
                    let icoObj = new Object
                    let bgcObj = new Object
                    if(res.logoUrl){
                        logoObj.url = this.$options.filters["filterUrl"](res.logoUrl);
                        this.logoList.push(logoObj)
                    }
                    if(res.icoUrl){
                        icoObj.url = this.$options.filters["filterUrl"](res.icoUrl);
                        this.icoList.push(icoObj)
                    }
                    if(res.bgUrl){
                        bgcObj.url = this.$options.filters["filterUrl"](res.bgUrl);
                        this.bgcList.push(bgcObj)
                    }
                    if(res.pageFooter && res.pageFooter !== "{}"){
                        this.flag = true
                        this.footForm = JSON.parse(res.pageFooter)
                    }
                }else{
                    this.dataForm = { shenbaoId: id }
                }
            })
        },
        handleExceed: function () {
            this.$message.warning('请先删除之前的图片，再上传新的图片!');
        },
        uploadImg(file){
            let obj = new Object
            let type = typeof file
            if(type=='object'){
                this.dataForm.bgUrl = file.originalPath
                obj.url = this.$options.filters["filterUrl"](file.originalPath)
                this.bgcList.push(obj)
            }else if(type=='string'){
                this.bgcList = []
            }else{
                this.bgcList = []
                this.$message.error('上传失败，请重新上传！');
            }
        },
        selectChange(file){
            const { raw } = file;
            this.openCropper(raw);
        },
        openCropper (file) {
            const is2M = file.size / 1024 / 1024  < 4;
            if (['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) == -1) {
                this.$message.error('请上传JPG或者PNG的图片格式');
                this.bgcList = []
                return false;
            }
            if (!is2M) {
                this.$message.error('上传图片大小不能超过4MB!');
                this.bgcList = []
                return false;
            }
            var reader = new FileReader();
            reader.onload = e => {
                let data;
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.cropperImg = data
            };
            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            // this.showCropper = true;
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate(valid => {
                 if (valid) {
                    let opFun = this.dataForm.id ? update : add;
                    let newForm = {}
                    if(this.flag) {
                        newForm = {
                            ...this.dataForm,
                            pageFooter: JSON.stringify(this.footForm)
                        }
                    }else{
                        newForm = {
                            ...this.dataForm,
                            pageFooter: "{}"
                        }
                    }
                    opFun(newForm).then(()=>{
                        this.$emit('close')
                        this.$message.success("操作成功");
                    })
                }else return false;
            });
        },
        beforeLogoUpload(file){
            const is2M = file.size / 1024 / 1024  < 2;
            if (['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) == -1) {
                this.$message.error('请上传JPG或者PNG的图片格式');
                return false;
            }
            if (!is2M) {
                this.$message.error('上传图片大小不能超过2MB!');
                return false;
            }
        },
        beforeIcoUpload(file){
            const is50K = file.size / 1024   < 50;
            if (['image/jpeg','image/x-icon', 'image/png', 'image/gif'].indexOf(file.type) == -1) {
                this.$message.error('请上传ico等图片格式');
                return false;
            }
            if (!is50K) {
                this.$message.error('上传ICO大小不能超过50KB!');
                return false;
            }
        },
        handleLogoSuccess(res){
            let obj = new Object
            if(res.data){
                this.dataForm.logoUrl = res.data.originalPath
                obj.url = this.$options.filters["filterUrl"](res.data.originalPath)
                this.logoList.push(obj)
            }else{
                this.$message.error('上传失败，请重新上传！');
            }
        },
        handleBgcSuccess(res){
            let obj = new Object
            if(res.data){
                this.dataForm.bgUrl = res.data.originalPath
                obj.url = this.$options.filters["filterUrl"](res.data.originalPath)
                this.bgcList.push(obj)
            }else{
                this.$message.error('上传失败，请重新上传！');
            }
        },
        handleIcoSuccess(res){
            let obj = new Object
            if(res.data){
                this.dataForm.icoUrl = res.data.originalPath
                obj.url = this.$options.filters["filterUrl"](res.data.originalPath)
                this.icoList.push(obj)
            }else{
                this.$message.error('上传失败，请重新上传！');
            }
        },
        handLogoRemove(){
            this.logoList = []
        },
        handIcoRemove(){
            this.icoList = []
        },
        handBgcRemove(){
            this.bgcList = []
        }
    }
};
</script>
<style lang="less">
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>